import { mapActions } from 'vuex'
const Mixin = {
  methods: {
    ...mapActions(['getPointSortData', 'getHistoryData'])
  }
}
export default Mixin
